import { createStore } from 'satcheljs';
import { IGlobalSearchCalloutState } from './schema/IGlobalSearchCalloutState';

export const getGlobalSearchCalloutStore = createStore<IGlobalSearchCalloutState>('GlobalSearchResultCalloutState', {
  searchText: '',
  data: { results: [] },
  searching: false
});
